import React from 'react'
import { Ico } from '@/components/icons'
import { Sidebar, Topbar } from '@/components/AccountShell'
import { useLang } from '@/lib/lang'

const Properties = () => {
  const { t } = useLang()
  const p = t.acct.manage.properties

  const props = [
    { id: 1, name: "Casa Coral Gables", addr: "2455 SW 17th Ave · 33145", role: "role_primary", sqft: "1,840", year: "1962", health: 87, status: "active", visits: 47, plan: "Casa · $79", icon: "🏡" },
    { id: 2, name: "Mami's house",       addr: "4218 NW 8th St · 33126",  role: "role_caretaker", sqft: "1,140", year: "1974", health: 72, status: "active", visits: 12, plan: "Casita · $39", icon: "🏠" },
    { id: 3, name: "Brickell rental",    addr: "1085 Brickell Bay Dr · 33131", role: "role_owner", sqft: "920", year: "2008", health: 91, status: "active", visits: 8, plan: "Casita · $39", icon: "🏢" },
  ]
  return (
    <div className="app-shell">
      <Sidebar active="props"/>
      <div className="main-pane">
        <Topbar crumbs={[t.acct.nav.properties]}/>
        <div className="content">
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "end", marginBottom: 18 }}>
            <div>
              <div className="kicker accent" style={{ marginBottom: 10 }}>◆ {p.since}</div>
              <h1 className="h-display" style={{ fontSize: 36, margin: 0 }}>
                {p.title_1} <span className="font-serif" style={{ color: "var(--terracotta)", fontWeight: 400 }}>{p.title_2}</span>
              </h1>
            </div>
            <button className="btn btn-primary" style={{ padding: "10px 16px", fontSize: 13 }}>
              <Ico.plus/> {p.add_property}
            </button>
          </div>

          <div style={{ display: "grid", gap: 14 }}>
            {props.map((prop, i) => (
              <div key={prop.id} className="tile" style={{ padding: 0, overflow: "hidden", display: "grid", gridTemplateColumns: "220px 1fr auto" }}>
                {/* Photo */}
                <div className="photo" style={{ aspectRatio: "auto", minHeight: 180, position: "relative", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 60 }}>
                  {prop.icon}
                  {i === 0 && (
                    <div style={{ position: "absolute", top: 12, left: 12, padding: "3px 8px", borderRadius: 999, background: "var(--terracotta)", color: "var(--cream)", fontFamily: "'Geist Mono', monospace", fontSize: 9, fontWeight: 600 }}>★ {p.primary}</div>
                  )}
                </div>

                <div style={{ padding: 22 }}>
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "start", marginBottom: 6 }}>
                    <div>
                      <div className="h-display" style={{ fontSize: 22 }}>{prop.name}</div>
                      <div style={{ fontSize: 13, color: "var(--muted)", display: "flex", alignItems: "center", gap: 6, marginTop: 2 }}>
                        <Ico.pin/> {prop.addr}
                      </div>
                    </div>
                    <span style={{ padding: "3px 8px", borderRadius: 999, background: "var(--cream-2)", fontFamily: "'Geist Mono', monospace", fontSize: 10, fontWeight: 600, color: "var(--cocoa)" }}>{p[prop.role]}</span>
                  </div>

                  <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: 16, marginTop: 18, paddingTop: 14, borderTop: "1px solid var(--line)" }}>
                    <div>
                      <div className="font-mono" style={{ fontSize: 9, color: "var(--muted)" }}>{p.health_col}</div>
                      <div style={{ display: "flex", alignItems: "center", gap: 8, marginTop: 4 }}>
                        <div className="h-display" style={{ fontSize: 22, color: prop.health > 80 ? "var(--sage)" : prop.health > 65 ? "var(--gold)" : "var(--terracotta)" }}>{prop.health}</div>
                      </div>
                    </div>
                    <div>
                      <div className="font-mono" style={{ fontSize: 9, color: "var(--muted)" }}>{p.square_feet}</div>
                      <div className="h-display" style={{ fontSize: 22, marginTop: 4 }}>{prop.sqft}<span style={{ fontSize: 12, color: "var(--muted)", marginLeft: 4 }}>ft²</span></div>
                    </div>
                    <div>
                      <div className="font-mono" style={{ fontSize: 9, color: "var(--muted)" }}>{p.year_built}</div>
                      <div className="h-display" style={{ fontSize: 22, marginTop: 4 }}>{prop.year}<span style={{ fontSize: 12, color: "var(--muted)", marginLeft: 6 }}>· {prop.visits}</span></div>
                    </div>
                    <div>
                      <div className="font-mono" style={{ fontSize: 9, color: "var(--muted)" }}>{p.plan_col}</div>
                      <div style={{ fontSize: 14, fontWeight: 600, marginTop: 4 }}>{prop.plan}</div>
                    </div>
                  </div>
                </div>

                <div style={{ padding: 22, display: "flex", flexDirection: "column", gap: 8, justifyContent: "center", borderLeft: "1px solid var(--line)" }}>
                  <button className="btn btn-primary" style={{ padding: "8px 14px", fontSize: 12 }}>{p.book_visit}</button>
                  <button className="btn btn-ghost" style={{ padding: "8px 14px", fontSize: 12 }}>{p.open_dashboard}</button>
                  <button className="font-mono" style={{ background: "transparent", border: "none", color: "var(--muted)", fontSize: 10, cursor: "pointer", paddingTop: 4 }}>{p.manage_access}</button>
                </div>
              </div>
            ))}
            <button className="dashed-card" style={{ padding: 24, textAlign: "center", border: "1px dashed var(--line-strong)", background: "transparent", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", gap: 10, color: "var(--muted)" }}>
              <Ico.plus/> <span style={{ fontWeight: 500 }}>{p.add_property}</span>
              <span className="font-mono" style={{ fontSize: 10, marginLeft: 8 }}>{p.invite_family}</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default function ManagePropertiesPage() {
  return <Properties />
}
